export default __webpack_public_path__ + "static/media/sunglasses_PNG95.42c3f2f3.png";